import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Invoice } from '../models/invoice';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private invoiceSource = new BehaviorSubject<Invoice | null>(null);
  currentInvoice = this.invoiceSource.asObservable();

  constructor() {}

  updateInvoice(invoice: Invoice) {
    this.invoiceSource.next(invoice);
  }
}
